<div class="modal-header">
  <h4 class="modal-title"> {{'editProjectOptionDefPopup.edit_title' | translate}} </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form">

      <div class="mb-3 row">
        <label class="col-md-4">{{'editProjectOptionDefPopup.label_identifier' | translate}}: *</label>
        <div class="col-md-8">
          <input type="text" class="form-control" formControlName="identifier" inputRestricter="^[0-9]*$"
                 [readonly]="editOption.isDefault"
                 [class.is-invalid]="checkControlValidity('identifier')">
          <div class="invalid-feedback">{{form.controls.identifier.errors?.messageKey | translate: {'0': form.controls.identifier.errors?.param} }}</div>
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-md-4">{{'editProjectOptionDefPopup.label_optionName' | translate}}: *</label>
        <div class="col-md-8">
          <input type="text" class="form-control" formControlName="name"
                 [readOnly]="isProjectOptionWithFixedName()"
                 [class.is-invalid]="checkControlValidity('name')">
          <div class="invalid-feedback">{{form.controls.name.errors?.messageKey | translate: {'0': form.controls.name.errors?.param} }}</div>
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-md-4">{{'changeProjectOptionDefPopup.label_defaultValue' | translate}}:{{defaultValueRequired ? ' *' : ''}}</label>
        <div class="col-md-8">
          <input type="text" class="form-control" spellcheck="false" formControlName="defaultValue" *ngIf="!editOption.isMultiLine"
                 [class.is-invalid]="checkControlValidity('defaultValue')">
          <textarea class="form-control" rows="4" formControlName="defaultValue" *ngIf="editOption.isMultiLine" spellcheck="false"
                    [class.is-invalid]="checkControlValidity('defaultValue')"></textarea>
          <div class="invalid-feedback">{{form.controls.defaultValue.errors?.messageKey | translate: {'0': form.controls.defaultValue.errors?.param} }}</div>
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-md-4">{{'editProjectOptionDefPopup.label_visible' | translate}}:</label>
        <div class="col-md-8">
          <div class="form-check">
            <input id="visible" type="checkbox" class="form-control" formControlName="isVisible">
            <label for="visible" class="form-check-label"></label>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button type="submit" class="btn btn-primary btn-forward" (click)="save()">
    {{'global.label.ok' | translate}}
  </button>
</div>
